module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "telCon"
  }, [_c('p', {
    staticClass: "tel"
  }, [_vm._v("咨询热线：400-168-6606")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("（周一至周日：7:00 - 24:00）")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c530c06!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/footer/HomeTel.vue
// module id = 138
// module chunks = 1